export default __webpack_public_path__ + "static/media/Rainbow-Chickens-Logo.26e8f562.png";